<template>
  <div v-if="configAttrs" class="app-gg-config-wrapper">
    <ConfigAside
      :logo-path="logoPath"
      :config-attrs="configAttrs"
      :search-terms="searchTerms"
      :current-search-term="currentSearchTerm"
      @changeCurrentSearchTerm="changeCurrentSearchTerm" />

    <GeogridMap
      :geogrid="currentGeogrid"
      :map-key="mapKey"
      :initial-center="[configAttrs.gridCenterLng, configAttrs.gridCenterLat]"
      :features="{
        searchZones: true,
        zipZones: true,
        inmapStats: true,
        inmapBusiness: false
      }" />

    <SearchTermGeogrids
      v-if="currentSearchTerm.ggsSyncState === GGS_SYNC_STATES.SUCCESS"
      :geogrids="currentSearchTerm.geogrids"
      :current-geogrid="currentGeogrid"
      @changeCurrentGeogrid="changeCurrentGeogrid" />

    <footer v-else-if="[GGS_SYNC_STATES.INITIAL, GGS_SYNC_STATES.SYNCING].includes(currentSearchTerm.ggsSyncState)">
      <div class="spinner-wrapper">
        <i class="far fa-fw fa-spin fa-spinner-third" />
      </div>
    </footer>

    <footer v-else-if="currentSearchTerm.ggsSyncState === GGS_SYNC_STATES.FAILED">
      failed
    </footer>
  </div>
</template>

<script>
import axiosTransform from 'common/axios'

import ConfigAside from './show/config_aside'
import GeogridMap from '../components/geogrid_map'
import SearchTermGeogrids from './show/search_term_geogrids'

const fetchGeogridConfig = (configId) => axios.get(`/stats/api/geogrid_configs/${configId}`, axiosTransform)
const fetchGeogrids = (configId, searchTermId) => axios.get(`/stats/api/geogrid_configs/${configId}/geogrids?search_term_id=${searchTermId}`, axiosTransform)

const GGS_SYNC_STATES = {
  INITIAL: 'INITIAL',
  SYNCING: 'SYNCING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED'
}

export default {
  components: { ConfigAside, GeogridMap, SearchTermGeogrids },
  props: {
    geogridConfigId: { type: String, required: true },
    logoPath: { type: String, required: true },
    mapKey: { type: String, required: true }
  },
  data() {
    return {
      configAttrs: null,
      searchTerms: [],
      scheduleFormatted: null,
      nextGeneration: null,
      currentSearchTerm: null,
      currentGeogrid: null
    }
  },
  created() {
    this.GGS_SYNC_STATES = GGS_SYNC_STATES
    fetchGeogridConfig(this.geogridConfigId)
      .then((res) => {
        const {
          configAttrs, searchTerms
        } = res.data
        this.searchTerms = searchTerms.map((st) => ({
          ...st,
          geogrids: null,
          ggsSyncState: GGS_SYNC_STATES.INITIAL
        }))
        this.currentSearchTerm = this.searchTerms.at(0)

        this.configAttrs = configAttrs
      })
  },
  methods: {
    changeCurrentSearchTerm(searchTerm) {
      this.currentSearchTerm = searchTerm
    },
    changeCurrentGeogrid(geogrid) {
      this.currentGeogrid = geogrid
    }
  },
  watch: {
    currentSearchTerm(searchTerm) {
      if (searchTerm.ggsSyncState === GGS_SYNC_STATES.INITIAL) {
        searchTerm.ggsSyncState = GGS_SYNC_STATES.SYNCING
        this.currentGeogrid = null
        fetchGeogrids(this.geogridConfigId, searchTerm.id)
          .then((res) => {
            searchTerm.ggsSyncState = GGS_SYNC_STATES.SUCCESS
            searchTerm.geogrids = res.data
            this.currentGeogrid = searchTerm.geogrids.length ? searchTerm.geogrids.at(-1) : null
          })
          .catch(() => {
            searchTerm.ggsSyncState = GGS_SYNC_STATES.FAILED
          })
      } else if (searchTerm.ggsSyncState === GGS_SYNC_STATES.SUCCESS) {
        this.currentGeogrid = searchTerm.geogrids.at(-1)
      } else {
        this.currentGeogrid = null
      }
    }
  }
}
</script>
